import React from "react";
import PropTypes from "prop-types";

const ToggleSwitch = ({
  isEnabled,
  onToggle,
  labelOn,
  labelOff,
  title,
  name,
}) => {
  const currentLabel = isEnabled ? labelOn : labelOff;

  return (
    <div className="w-full">
      {title && (
        <label className="block text-sm font-medium text-primary mb-1">
          {title}
        </label>
      )}

      <label className="flex items-center gap-3 cursor-pointer select-none">
        <input
          type="checkbox"
          name={name}
          checked={isEnabled}
          onChange={onToggle}
          className="sr-only"
        />

        <span
          className={`relative inline-flex h-6 w-11 items-center rounded-full border shadow-sm transition ${
            isEnabled
              ? "bg-[#a2c992] border-gray-300"
              : "bg-[#DF4659] border-gray-300"
          }`}
        >
          <span
            className={`inline-block h-5 w-5 rounded-full bg-white shadow transition ${
              isEnabled ? "translate-x-5" : "translate-x-0.5"
            }`}
          />
        </span>

        {currentLabel && (
          <span className="text-sm text-primary">{currentLabel}</span>
        )}
      </label>
    </div>
  );
};

ToggleSwitch.propTypes = {
  isEnabled: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  labelOn: PropTypes.string,
  labelOff: PropTypes.string,
  title: PropTypes.string,
  name: PropTypes.string,
};

ToggleSwitch.defaultProps = {
  labelOn: "",
  labelOff: "",
  title: "",
  name: "",
};

export default ToggleSwitch;
